<style lang="scss" scoped>
.v-card--reveal {
  position: absolute;
  bottom: 0;
  align-items: center;
  justify-content: center;
  width: 100%;
  background-color: rgba(#ffffff, 0.5);
  gap: 20px;
}
.relative {
  position: relative;
  height: 90%;
}
.screenshot {
  display: flex;
  gap: 15px;
  &__order {
    background-color: #fff;
    border-radius: 4px;
    color: #000;
    font-size: 16px !important;
    font-weight: 400 !important;
  }
  &__caption {
    position: absolute;
    right: 0.5rem;
    bottom: 0;
    z-index: 0;
    padding: 0 0.5rem;
    border-radius: 2px;
    color: rgb(197, 80, 80);
    background: rgba(#fff, 0.8);
  }
  &__finding{
    height: 28px;
    width: 28px;
    margin: 0;
  }
  &__hover-icon{
    height: 32px;
    width: 32px;
    margin: 0;
  }
  &--card{
    border-radius: 5px 5px 0 0;
  }
  &--image{
    height: 157px;
  }
  &--title{
    background-color: #B6BAC3;
    height:32px;
    padding: 0 5px 0px 10px;
    display: grid;
    grid-template-columns: 1fr 30px;
  }
  &--print {
    background-color: #14B8A6;
    border-radius: 0 0 5px 5px;
  }

  &--print_disabled {
    background-color: #607d8b;
  }

  &__finding.v-btn.v-btn--outline {
    border-width: 2px;
  }
  &--card-actions > * {
    display: flex;
    align-items: center;
    gap: 10px;
  }
}
.right-action,.right-action:hover{
  position: absolute;
  right: 10px;
}
.right-action2,.right-action2:hover{
  position: absolute;
  right: 40px;
}
.action-btn::before{
  background: transparent !important;
  display: none !important;
}
.action-btn{
  background-color: rgba(222,222,222, 0.4) ; 
  border-radius: 50%;
  position: absolute !important;;
  right: 0px;
  width:36px !important;
  height:36px;
  z-index: 1;
  display: block;
}
</style>

<template>
  <v-flex xs12 sm6 lg4 class="">
    <v-hover>
      <v-card slot-scope="{ hover }" dark color="grey lighten-4" class="screenshot--card">
        <div class="relative">
          <v-btn
            icon
            flat             
            small
            class="action-btn print"
            v-if="statusIcon === 'check' || hover"
            @click.stop="changePrintStatus"
          >
            <v-icon :color="hover ? '#ccaa33' : '#10B981'" class="status-icon">
              check
            </v-icon>
          </v-btn>
          <v-img aspect-ratio="1.33333" class="screenshot--image" :src="imgSrc">
            <v-expand-transition>
              <v-layout v-if="hover" class="v-card--reveal fill-height ma-0">
              <!-- <v-layout class="v-card--reveal fill-height ma-0"> -->
                <v-btn small fab flat color="light-green" class="screenshot__hover-icon" @click="download">
                  <v-icon medium color="#6B6B6B">cloud_download</v-icon>
                </v-btn>
                <v-btn small fab flat class="screenshot__hover-icon" @click="zoom">
                  <img alt="zoomout" src="~@/assets/icons/zoomout.png" />
                </v-btn>
                <!-- <v-btn small fab flat color="light-green" class="screenshot__hover-icon" @click="changePrintStatus">
                  <v-icon medium color="#6B6B6B">print</v-icon>
                </v-btn> -->
                
                <v-btn small fab flat color="deep-orange" class="screenshot__hover-icon" @click="notify('remove')">
                  <v-icon medium color="#6B6B6B">delete_outline</v-icon>
                </v-btn>
              </v-layout>
            </v-expand-transition>

            <template #placeholder>
              <v-layout fill-height align-center justify-center ma-0>
                <v-progress-circular indeterminate color="grey lighten-5" />
              </v-layout>
            </template>
          </v-img>
          <p
            class="screenshot__caption"
            v-if="printIcon.name === 'print_disabled'"
          >
            {{ $t('report.image_not_show_on_print') }}
          </p>
        </div>

        <v-card-actions :class="`screenshot--${printIcon.name}`">
          <h6 class="mr-1 py-1 px-2 title text-xs-center screenshot__order" >
            P {{ info.imgSerial }}
          </h6>
          <h5 >{{ cm }}</h5>
          <div class="screenshot__landmark-text">{{findingName}}{{ findingName !=='' && landmarkText !='' ?' , ':'' }} {{ transI18n(landmarkText) }}</div>
          <!-- <v-btn icon @click="changePrintStatus">
            <v-icon large :color="printIcon.color">{{ printIcon.name }}</v-icon>
          </v-btn> -->
          <select-icon
            :value="info.landmarkID"
            :items="landmarks"
            @change="changeLandmark"
            class="right-action"
          >
            <template #default="{ on }">
              <v-btn icon small flat :color="landmarkIconColor" v-on="on" class="right-action">
                <v-icon small >arrow_downward</v-icon>
              </v-btn>
              <!-- <font v-if="!landmarkText">{{ $t('report.select_landmarks') }}</font> -->
            </template>
          </select-icon>
          <select-icon
            :value="info.findingID"
            :items="findings"
            @change="changeFinding"
            class="right-action"
          >
            <template #default="{ on }">
              <v-btn
                v-if="findingOrder"
                icon
                flat
                slim
                size="small"
                class="screenshot__finding right-action2"
                v-on="on"
              >
                <img alt="subtract" src="~@/assets/icons/subtract.png" />
              </v-btn>
              <v-btn v-else icon flat size="x-small" v-on="on" class="screenshot__finding  right-action2">
                <img alt="subtract" src="~@/assets/icons/subtract.png" />
              </v-btn>
            </template>
          </select-icon>
        </v-card-actions>
        <!-- <v-card-actions :class="landmarkBarColor">
          <select-icon
            :value="info.landmarkID"
            :items="landmarks"
            @change="changeLandmark"
          >
            <template #default="{ on }">
              <v-btn icon flat :color="landmarkIconColor" v-on="on">
                <v-icon medium>location_on</v-icon>
              </v-btn>
              <font v-if="!landmarkText">{{ $t('report.select_landmarks') }}</font>
            </template>
          </select-icon>
          <div class="title grey--text text--darken-2">
            {{ landmarkText }}
          </div>
        </v-card-actions> -->
      </v-card>
    </v-hover>
  </v-flex>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import SelectIcon from '../screenshots/SelectIcon'
import common from '@/utils/common'
import { findMatchI18n } from '@/utils/findMatchI18n'
const NOTIFY = {
  REMOVE: 'remove',
}
const STATUS = {
  NO: '0',
  YES: '1',
}
const STATUS_CHANGE = [STATUS.YES, STATUS.NO]

export default {
  name: 'Screenshot',
  components: {
    SelectIcon,
  },
  props: {
    info: {
      type: Object,
      default: () => ({}),
    },
    findings: {
      type: Array,
      default: () => [],
    },
    landmarks: {
      type: Array,
      default: () => [],
    },
    length: {
      type: Number,
      default: 0,
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    ...mapGetters('examinations', [
      'getExaminationData',
      'getExaminationTypeList',
      'getPatient',
      'getFindingNameMap',
    ]),
    imgSrc() {
      return this.info && this.info.file
        ? `/api/upload/image/${this.info.examinationID}/${this.info.file}`
        : ''
    },
    order() {
      return this.length - this.index
    },
    cm() {
      return this.info && this.info.cm ? `${this.info.cm} cm` : ''
    },
    statusIcon() {
      return this.info?.status == 0 ? 'print' : 'check'
    },
    printIcon() {
      return this.info && this.info.status === STATUS.YES
        ? { name: 'print', color: 'white' }
        : { name: 'print_disabled', color: '#ff5722' }
    },
    findingOrder() {
      if (this.info) {
        if (this.info.findingID) {
          return this.findings.findIndex((f) => f.value === this.info.findingID)
        }
      }
      return 0
    },
    getFindings() {
      return this.getExaminationData ? this.getExaminationData.findings : null;
    },
    findingName() {
      if (!this.getFindings) {
        return ''
      }
      const findingMap = this.getFindings.find(row => row.id === this.info.findingID)
      if (findingMap) {
        const findingMapId = findingMap.questions.finding.value
        return findMatchI18n(this.getFindingNameMap[findingMapId])
      }
      return ''
    },
    landmarkText() {
      if (this.landmarks.length && this.info.landmarkID) {
        const found = this.landmarks.find(
          (l) => l.value === this.info.landmarkID,
        )
        if (found) {
          return found.text.replace(/(\Wof\Wcolon|\Wcolon)$/gi, '')
        }
      }
      return ''
    },
    landmarkBarColor() {
      return this.landmarkText ? 'yellow accent-4' : 'blue-grey'
    },
    landmarkIconColor() {
      return this.landmarkText ? 'deep-orange' : ''
    },
  },
  methods: {
    ...mapActions('screenshots', ['deleteScreenshot']),
    ...mapActions('examinations', [
      'imgLandmarkChange',
      'updateScreenshotStatusInFinding',
      'updateScreenshotStatusInAll',
      'moveImgFromAllToFinding',
    ]),
    transI18n(value) {
      return findMatchI18n(value)
    },
    toImgURL(url) {
      return fetch(url)
        .then((response) => response.blob())
        .then((blob) => URL.createObjectURL(blob))
    },
    async download() {
      const a = document.createElement('a')
      a.href = await this.toImgURL(this.imgSrc)
      a.download = `${common.fileRule(
        this.getExaminationData,
        this.getExaminationTypeList,
        this.getPatient,
      )}_${this.imgSrc.replace(/^.*[\\\/]/, '')}`
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    notify(action) {
      switch (action) {
        case NOTIFY.REMOVE:
          this.remove()
          break
        default:
          break
      }
    },
    remove() {
      this.$emit('notify', {
        value: true,
        msg: this.$t('report.confirm.delete_image'),
        onConfirm: () => this.deleteScreenshot(this.info.id),
      })
    },
    changeLandmark(newValue) {
      this.imgLandmarkChange({
        imgID: this.info.id,
        newValue,
        page: 'r',
      })
    },
    changePrintStatus() {
      const params = {
        newStatus: STATUS_CHANGE[this.info.status],
        item: this.info,
        imgID: this.info.id,
        findingID: this.info.findingID,
        landmarkID: this.info.landmarkID,
      }
      if (this.info.findingID !== 0) {
        this.updateScreenshotStatusInFinding(params)
      } else {
        this.updateScreenshotStatusInAll({ ...params, imgIndex: this.index })
      }
    },
    changeFinding(newValue) {
      this.moveImgFromAllToFinding({
        imgID: this.info.id,
        newValue,
      })
    },
    zoom() {
      this.$emit('zoom', this.imgSrc)
    },
  },
}
</script>
